// for progress, vocab, subsription
// src/context/UserDataContext.js
import React, { createContext, useContext, useEffect, useState } from "react";
import { subscribeUserProfile } from "../data/accountRepo";
import { useAuth } from "./AuthContext";

// 1) Create the context
const UserDataContext = createContext(null);

// 2) Export a custom hook for convenience
export const useUserData = () => useContext(UserDataContext);

// 3) Provider component
export function UserDataProvider({ children }) {
  const { user } = useAuth(); // Firebase auth user (has uid, email)
  const [userData, setUserData] = useState(null); // Firestore profile
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user?.uid) {
      setUserData(null);
      setLoading(false);
      return;
    }
  
    setLoading(true);
  
    const unsubscribe = subscribeUserProfile({
      uid: user.uid,
      onData: (data) => {
        if (data) {
          setUserData(data);
        } else {
          setUserData({
            hasAccess: false,
            subscriptionStatus: "none",
            progress: {},
            vocab: [],
          });
        }
        setLoading(false);
      },
      onError: (error) => {
        console.error("Error fetching user data:", error);
        setUserData(null);
        setLoading(false);
      },
    });
  
    return unsubscribe;
  }, [user?.uid]);
  

  // Provide userData + helper states
  return (
    <UserDataContext.Provider value={{ userData, loading }}>
      {children}
    </UserDataContext.Provider>
  );
}
